import { Image } from 'expo-image';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Text, tokens } from '@fhs/ui';

export function RedemptionRules({ isCanada }: { isCanada: boolean }) {
  return (
    <View style={styles.container}>
      <Text.Ui size="lg" weight="semibold">
        Redemption Rules
      </Text.Ui>
      <Text.Ui size="sm" style={styles.description}>
        If you're eligible, you can redeem a{' '}
        <Text.Ui size="sm" weight="semibold">
          free medium sub
        </Text.Ui>
        {isCanada ? ' ' : ' with the purchase of any item '}
        during the Redemption Window.
      </Text.Ui>

      <View style={styles.offerContainer}>
        <View style={styles.imageContainer}>
          <Image source={require('./free-sub.png')} style={{ width: '100%', height: '100%' }} />
        </View>
        <View style={styles.offerTextContainer}>
          <Text.Ui size="md" weight="semibold">
            Free Medium Sub
          </Text.Ui>
          <Text.Ui size="sm" style={styles.offerDescription}>
            {isCanada
              ? 'Choose from any available sub options.'
              : 'Choose from any available sub options with any purchase.'}
          </Text.Ui>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 24,
  },
  description: {
    marginTop: 8,
  },
  offerContainer: {
    marginTop: 16,
    flexDirection: 'row',
    backgroundColor: tokens.colors.$blackOpacity04,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageContainer: {
    width: 48,
    height: 48,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity04,
    borderRadius: 4,
    padding: 8,
  },
  offerTextContainer: {
    flex: 1,
    paddingLeft: 12,
  },
  offerDescription: {
    marginTop: 4,
  },
});
